import {
  LayoutDashboard,
  Wifi,
  Cpu,
  BarChart3,
  Scale,
  ReceiptText,
} from 'lucide-react';

export const sidebarMenu = [
  {
    id: 'home',
    title: 'میزکار',
    icon: BarChart3,
    path: '/',
    badge: null,
  },
  {
    id: 'gateway',
    title: 'هاب ها',
    icon: Wifi,
    path: '/gateway',
    badge: null,
  },
  {
    id: 'devices',
    title: 'دستگاه‌ ها',
    icon: Cpu,
    path: '/devices',
    badge: null,
  },
  {
    id: 'dashboard',
    title: 'داشبوردها',
    icon: LayoutDashboard,
    path: '/dashboard',
    badge: null,
  },
  {
    id: 'rules',
    title: 'هشدار و اعلان ها',
    icon: Scale,
    path: '/rules?tab=alert',
    badge: null,
  },
  {
    id: 'billing',
    title: 'امور مالی',
    icon: ReceiptText,
    path: '/subscription',
    badge: null,
  },
];
